import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    toggle() {
        this.menuTarget.classList.toggle("hidden")
    }

    close(event) {
        if (this.menuTarget.classList.contains("hidden")) return
        if (!this.element.contains(event.target)) {
            this.menuTarget.classList.add("hidden")
        }
    }
}
